var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchAwsGlueElasticViews32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture/32/Arch_AWS-Glue-Elastic-Views_32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D27A8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A166FF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture/32/Arch_AWS-Glue-Elastic-Views_32",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon-Service/32/AWS-Glue-Elastic-Views_32",
    transform: "translate(4.000000, 4.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17,14 L20,14 L20,15 L17,15 L17,18 L16,18 L16,15 L13,15 L13,14 L16,14 L16,11 L17,11 L17,14 Z M26.933,10.043 C25.627,10.043 25.049,9.698 25,9.597 L24.996,3.467 C25.051,3.347 25.633,3 26.933,3 C28.183,3 28.888,3.325 29,3.475 L29.008,9.559 C28.919,9.722 28.198,10.043 26.933,10.043 L26.933,10.043 Z M16.5,20 C13.468,20 11,17.533 11,14.5 C11,11.467 13.468,9 16.5,9 C19.532,9 22,11.467 22,14.5 C22,17.533 19.532,20 16.5,20 L16.5,20 Z M26.446,17 C27.362,17 27.867,17.208 28,17.311 L28.026,21.667 C27.955,21.756 27.447,22 26.446,22 C25.525,22 25.054,21.786 25,21.763 L24.979,17.315 C25.054,17.217 25.526,17 26.446,17 L26.446,17 Z M21,28.82 C20.865,28.893 20.513,29 19.959,29 C19.404,29 19.108,28.894 19,28.833 L19,25.168 C19.109,25.108 19.405,25 19.959,25 C20.512,25 20.864,25.108 21,25.182 L21,28.82 Z M5.419,26 C3.63,26 3,25.501 3,25.395 L3,18.606 C3.035,18.434 3.806,18 5.419,18 C7.043,18 7.913,18.436 8,18.617 L8.002,25.381 C7.936,25.557 7.069,26 5.419,26 L5.419,26 Z M7,9.82 C6.865,9.893 6.513,10 5.959,10 C5.404,10 5.108,9.894 5,9.833 L5,6.168 C5.109,6.108 5.405,6 5.959,6 C6.512,6 6.864,6.108 7,6.182 L7,9.82 Z M26.933,2 C25.151,2 24,2.567 24,3.446 L24,7.124 L20.949,9.774 C19.785,8.678 18.222,8 16.5,8 C14.219,8 12.213,9.184 11.053,10.966 L8,8.408 L8,6.064 C8,5.417 7.199,5 5.959,5 C4.751,5 4,5.408 4,6.064 L4,9.936 C4,10.592 4.751,11 5.959,11 C7.218,11 8,10.592 8,9.936 L8,9.713 L10.564,11.862 C10.205,12.669 10,13.561 10,14.5 C10,15.961 10.49,17.306 11.308,18.393 L9,20.435 L9,18.605 C9,17.497 7.201,17 5.419,17 C3.342,17 2,17.63 2,18.605 L2,25.395 C2,26.37 3.342,27 5.419,27 C7.071,27 9,26.58 9,25.395 L9,21.77 L11.964,19.147 C13.137,20.292 14.736,21 16.5,21 C16.881,21 17.252,20.96 17.614,20.897 L19.187,24.068 C18.44,24.208 18,24.563 18,25.064 L18,28.936 C18,29.592 18.751,30 19.959,30 C21.218,30 22,29.592 22,28.936 L22,25.064 C22,24.475 21.332,24.08 20.276,24.014 L18.605,20.644 C19.837,20.22 20.9,19.437 21.673,18.419 L24,19.436 L24,21.763 C24,22.526 24.937,23 26.446,23 C27.624,23 29,22.676 29,21.763 L29,17.237 C29,16.324 27.624,16 26.446,16 C24.937,16 24,16.474 24,17.237 L24,18.345 L22.227,17.57 C22.719,16.655 23,15.61 23,14.5 C23,12.997 22.482,11.616 21.623,10.514 L24,8.448 L24,9.597 C24,10.475 25.151,11.043 26.933,11.043 C28.348,11.043 30,10.664 30,9.597 L30,3.446 C30,2.447 28.459,2 26.933,2 L26.933,2 Z",
    id: "Fill-5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchAwsGlueElasticViews32);
export default __webpack_public_path__ + "static/media/Arch_AWS-Glue-Elastic-Views_32.2fa6fa9ac251d523eca81a8eaaa12751.svg";
export { ForwardRef as ReactComponent };